import React, {Component} from 'react';
import './InfluencerMap.css';
import CustomerGroups from './CustomerGroups/CustomerGroups';
import CustomerGroupsLevel from './CustomerGroupsLevel/CustomerGroupsLevel';
import CustomerGroupsInfluenceChange from './CustomerGroupsInfluenceChange/CustomerGroupsInfluenceChange';
import CustomerInfluencerMap from './CustomerInfluencerMap/CustomerInfluencerMap';
import InfluencerMapSelects from "./InfluencerMapSelects/InfluencerMapSelects";
import Result from './Result/Result';

class InfluencerMap extends Component {
    constructor(props) {
      super(props);
      this.defaultParams = {};
      let { page } = this.parseUrl();
      this.state = {
          groupStepState: +page || 1,
          disableNextState: false,
          backStep: false,
      };
    }

    parseUrl() {
        let search = window.location.search && window.location.search !== '' ? window.location.search.replace('?', '') : window.location.search;
        let paramsArray = search.split('&');
        let results = {};
        for (let a of paramsArray) {
            let d = a.split('=');
            results[d[0]] = d[1];
        }
        return results;
    }

    groupStateNext = (step) => {
        this.setState({  groupStepState: this.state.groupStepState + 1 })
    }

    groupStateBack = (step) => {
        this.setState({  groupStepState: this.state.groupStepState - 1, backStep: true })
    }
    complitedBackStep = () => { this.setState({ backStep : false }) }

    disableNextModal = () => {
        this.setState({ disableNextState : !this.state.disableNextState })
    }

    componentWillMount() {
        localStorage.setItem("openedTool", this.props.projectId);
    }

    render() {
        return(
            <div className='projects-content challenge-statement-content'>
                    {/* { !this.props.getInfluencerMapGroupsFetching &&  */}
                        <div>
                            {this.state.groupStepState === 1 &&
                                <CustomerGroups
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    addInfluencerMapGroups={this.props.addInfluencerMapGroups}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStateNext={this.groupStateNext}
                                    groupStepState={this.state.groupStepState}
                                    addInfluencerMapGroupsFetching={this.props.addInfluencerMapGroupsFetching}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                    disableNextModal={this.disableNextModal}
                                    disableNextState={this.state.disableNextState}
                                />
                            }

                            {this.state.groupStepState === 2 &&
                                <CustomerGroupsLevel
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    addInfluencerMapGroups={this.props.addInfluencerMapGroups}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStepState={this.state.groupStepState}
                                    groupStateNext={this.groupStateNext}
                                    groupStateBack={this.groupStateBack}
                                    disableNextModal={this.disableNextModal}
                                    disableNextState={this.state.disableNextState}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                />
                            }

                            {this.state.groupStepState === 3 &&
                                <CustomerGroupsInfluenceChange
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    addInfluencerMapGroups={this.props.addInfluencerMapGroups}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStepState={this.state.groupStepState}
                                    groupStateNext={this.groupStateNext}
                                    groupStateBack={this.groupStateBack}
                                    disableNextModal={this.disableNextModal}
                                    disableNextState={this.state.disableNextState}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                    backStep={this.state.backStep}
                                    complitedBackStep={this.complitedBackStep}
                                />
                            }

                            {this.state.groupStepState === 4 &&
                                <CustomerInfluencerMap
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    groupStateNext={this.groupStateNext}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStateBack={this.groupStateBack}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                />
                            }
                            {this.state.groupStepState === 5 &&
                                <InfluencerMapSelects
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStateNext={this.groupStateNext}
                                    groupStateBack={this.groupStateBack}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                    disableNextModal={this.disableNextModal}
                                    disableNextState={this.state.disableNextState}
                                    backStep={this.state.backStep}
                                    complitedBackStep={this.complitedBackStep}

                                />
                            }

                            {this.state.groupStepState === 6 &&
                                <Result
                                    projectId={this.props.projectId}
                                    getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                    getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                                    editInfluencerMapGroups={this.props.editInfluencerMapGroups}
                                    groupStateNext={this.groupStateNext}
                                    groupStateBack={this.groupStateBack}
                                    addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                                />
                            }

                        </div>
                    {/* }
                    { this.props.getInfluencerMapGroupsFetching &&
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    } */}




            </div>
        )
    }
}

export default (InfluencerMap);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/InfluencerMap.jsx